<template>
	<div class="pa-2">
		<b-search
			v-model="search"
			:add-name="$T('add')"
			class="mb-1"
			:bones="searchItems"
			@search="fetch()"
			@clear="fetch()"
			@add="openDialog"
		>
			<template #end>
				<div style="display: block">
					<v-btn @click="exportFile()" :loading="excelLoading" class="mx-1" small color="success">
						<v-icon small class="pe-1"> mdi-export </v-icon>
						تصدير لإكسل
					</v-btn>
				</div>
			</template>
		</b-search>

		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:data-table-props="{ disableSort: true }"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 190"
			pagination-on-scroll
			pagination-on-scroll-server-items
			:pagination-on-scroll-loading="loading"
			:server-items-length="Number(itemsCount)"
			:items-per-page="30"
			:options-scroll.sync="scrollOptions"
			hide-default-footer
			@pagination-on-scroll:reach-last-row="fetch">
			<template v-slot:item.salary="{ item }">
				<tooltip
					text="مدفوعة"
					v-if="item.withSalary">
					<v-icon> mdi-cash-multiple </v-icon>
				</tooltip>

				<tooltip
					text="غير مدفوعة"
					v-else>
					<v-icon> mdi-cancel </v-icon>
				</tooltip>
			</template>
			<template v-slot:item.startDate="{ item }">
				{{
					moment(item.startTime).isValid()
						? moment(item.startTime).format(item.isDaily ? 'L' : 'LT')
						: '-'
				}}
			</template>
			<template v-slot:item.endDate="{ item }">
				{{
					moment(item.startTime).isValid()
						? moment(item.startTime)
								.add(
									item.isDaily ? item.durationInDay : item.durationInMinute,
									item.isDaily ? 'd' : 'm',
								)
								.format(item.isDaily ? 'L' : 'LT')
						: '-'
				}}
			</template>

			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<tooltip :text="$T('tooltips.employee')">
						<v-btn
							:to="{
								name: 'personal-info',
								query: { employeeId: item.employeeId },
							}"
							small
							icon>
							<v-icon
								size="20"
								color="preview">
								$viewEmployee
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.edit')">
						<v-btn
							small
							icon
							@click="
								openDialog({
									employee: item.employeeBrief.employeeId,
									item: item,
								})
							">
							<v-icon
								size="20"
								color="edit-color">
								$edit
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							small
							icon
							@click="
								deleteDialog = true;
								deleteItem = item.id;
							">
							<v-icon
								size="20"
								color="alert">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
				</div>
			</template>
		</bee-handy-table>

		<!-- add work dialog -->
		<v-dialog
			v-model="showDialog"
			max-width="400px"
			transition="dialog-transition">
			<b-add-vacation
				:vacation-type="0"
				:selected-item="dialogItem"
				:one-employee="dialogEmployee"
				@close="showDialog = false"
				@done="fetch()"></b-add-vacation>
		</v-dialog>

		<v-delete-dialog
			v-model="deleteDialog"
			:module="'attendance/deleteVacation'"
			:parameters="deleteItem"
			@on-delete="fetch">
			{{ $T('VacationAttendance.delete-message-vacation') }}
		</v-delete-dialog>
	</div>
</template>

<script>
import attendance from './attendance';
import BAddVacation from '@/components/forms/BAddVacation.vue';
import moment, { DATE_FORMAT } from '@/utils/moment';

export default {
	name: 'VacationAttendance',

	mixins: [attendance],

	components: { BAddVacation },

	data() {
		return {
			searchItems: [
				{
					type: 'name',
					value: 'NameOrCode',
				},
				{
					type: 'section',
					value: 'SectionId',
				},
				{
					type: 'leaveType',
					value: 'LeaveTypeId',
				},
				{
					type: 'toggle',
					value: 'toggle',
					items: [
						{
							name: 'مدة',
							for: ['DateTo', 'DateFrom'],
						},
						{
							name: 'يومي',
							for: ['Date'],
						},
					],
				},
				{
					type: 'from_date',
					value: 'DateFrom',
					toggle: 'toggle',
				},
				{
					type: 'to_date',
					value: 'DateTo',
					toggle: 'toggle',
				},
				{
					type: 'switch_date',
					value: 'Date',
					toggle: 'toggle',
					valuesAs: ['DateFrom', 'DateTo'],
				},
			],

			headers: [
				{
					text: '',
					value: 'salary',
					name: 'salary',
					sortable: false,
					width: 0,
					cellClass: 'pe-0 ps-2',
				},
				{ text: this.$T('table.employee'), value: 'employeeBrief.arabicFullName', name: 'employee' },
				{
					text: this.$T('headers.section-name'),
					value: 'employeeBrief.sectionName',
					name: 'section',
				},
				{
					text: this.$T('table.type'),
					value: 'leaveType',
					name: 'type',
					setValueExpr: (value, index) => value.name,
				},
				{
					text: this.$T('table.startDate'),
					value: 'startTime',
					name: 'startDate',
					cellClass: 'ltr',
				},
				{
					text: this.$T('table.endDate'),
					value: 'endDate',
					name: 'endDate',
					cellClass: 'ltr',
				},
				{ text: this.$T('table.cause'), value: 'reason', name: 'cause' },
				{
					text: this.$T('table.requestDate'),
					value: 'date',
					type: 'date',
					dateFormat: DATE_FORMAT,
					name: 'requestDate',
				},
				{ text: '', value: 'actions', name: 'actions', width: 40 },
			],

			storeModel: 'attendance/fetchVacations',

			search: {},
			storeParameter: {},

			vacationTypeId: null,
			vacationsTypes: [],
			excelLoading: false
		};
	},

	watch: {
		search: {
			handler(newVal) {
				this.storeParameter = {
					...newVal,
					IsNightShift: true,
				};
			},
			deep: true,
		},
	},

	methods: {
		calcEndDate(item) {
			return moment(item.startTime).isValid()
				? moment(item.startTime)
						.add(
							item.isDaily ? item.durationInDay : item.durationInMinute,
							item.isDaily ? 'd' : 'm',
						)
						.format('LT')
				: '-';
		},
		moment,
		exportFile() {
			this.excelLoading = true
			this.$store.dispatch('reports/fetchExcelLeave', {
				dateFrom : this.search.DateFrom,
				dateTo: this.search.DateTo,
				typeId: this.search.LeaveTypeId
			}).finally(() => {
				this.excelLoading = false
			})
		}
	},

	mounted() {
		this.storeParameter = {
			...this.search,
			IsNightShift: true,
		};
		this.fetch();
		this.$store.dispatch('attendance/fetchVacationsTypes').then((res) => {
			this.vacationsTypes = res;
		})
	},
};
</script>

<style lang="scss" scoped></style>
